module.exports = __webpack_public_path__ + "img/facilityInfo_3_0.ea84551a.jpg";